import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import LocationSelect from '../Selects/LocationSelect';
import CustomDatePicker from '../UI/CustomDatePicker';
import UserContext from '../../store/User/UserContext';
import { Location } from '../../types/Location.interface';
import { Worktype } from '../../types/Worktype.interface';
import LocationAutocomplete from '../Inputs/Autocomplete/LocationAutocomplete';
import WorktypeAutocomplete from '../Inputs/Autocomplete/WorktypeAutocomplete';

export type MultiSelectWorktypeLocDateRangeFilterProps = {
    locationOptions: Location[];
    selectedLocation: number;
    onSelectedLocationChange: (selectedLocation: number) => void;
    selectedLocations: Location | Location[];
    onSelectedLocationsChange: (selectedLocations: null | Location | Location[]) => void;
    worktypeOptions: Worktype[];
    selectedWorktypes: Worktype | Worktype[];
    onSelectedWorktypesChange: (selectedWorktypes: null | Worktype | Worktype[]) => void;
    startDate: Date;
    onStartDateChange: (startDate: Date) => void;
    endDate: Date;
    onEndDateChange: (endDate: Date) => void;
};

const MultiSelectWorktypeLocDateRangeFilter = ({
    locationOptions,
    selectedLocation,
    onSelectedLocationChange,
    selectedLocations,
    onSelectedLocationsChange,
    worktypeOptions,
    selectedWorktypes,
    onSelectedWorktypesChange,
    startDate,
    onStartDateChange,
    endDate,
    onEndDateChange,
}: MultiSelectWorktypeLocDateRangeFilterProps) => {
    const { t } = useTranslation('allDeltas');
    const loggedInUser = useContext(UserContext);

    return (
        <>
            {loggedInUser?.isOSPUser && (
                <Grid item xs={12} md={5} lg={3}>
                    <LocationSelect
                        selectedLocation={selectedLocation}
                        locationOptions={locationOptions}
                        onChange={onSelectedLocationChange}
                    ></LocationSelect>
                </Grid>
            )}
            {(loggedInUser?.isWFMUser || loggedInUser?.isWTMUser) && (
                <Grid item xs={12} md={5} lg={3}>
                    <LocationAutocomplete
                        label={t('field.location')}
                        selectedLocation={selectedLocations}
                        locationOptions={locationOptions}
                        onChange={onSelectedLocationsChange}
                        isMultiSelect={true}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={6} lg={3}>
                <WorktypeAutocomplete
                    label={t('field.worktype')}
                    worktypeOptions={worktypeOptions}
                    selectedWorktype={selectedWorktypes}
                    onChange={onSelectedWorktypesChange}
                />
            </Grid>
            <Grid item>
                <CustomDatePicker
                    label={t('field.start')}
                    date={startDate}
                    views={['year', 'month']}
                    openTo="month"
                    onChange={onStartDateChange}
                ></CustomDatePicker>
            </Grid>
            <Grid item>
                <CustomDatePicker
                    label={t('field.end')}
                    date={endDate}
                    views={['year', 'month']}
                    openTo="month"
                    onChange={onEndDateChange}
                ></CustomDatePicker>
            </Grid>
        </>
    );
};

export default MultiSelectWorktypeLocDateRangeFilter;
